var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "441.378,88.276 441.378,423.724 105.93,88.276 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M207.351,213.176l5.088,15.254l16.079,0.125c1.246,0.01,1.762,1.599,0.76,2.339l-12.936,9.553 l4.851,15.331c0.376,1.187-0.977,2.17-1.991,1.446l-13.082-9.351l-13.082,9.351c-1.013,0.724-2.366-0.258-1.991-1.446l4.851-15.331 l-12.936-9.553c-1.002-0.74-0.486-2.329,0.76-2.339l16.079-0.125l5.088-15.254C205.286,211.994,206.957,211.994,207.351,213.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M170.57,176.394l5.088,15.254l16.079,0.125c1.246,0.01,1.762,1.6,0.76,2.339l-12.936,9.553 l4.851,15.331c0.376,1.187-0.977,2.17-1.991,1.446l-13.082-9.351l-13.082,9.351c-1.013,0.725-2.366-0.258-1.991-1.446l4.851-15.331 l-12.936-9.553c-1.002-0.74-0.486-2.329,0.76-2.339l16.079-0.125l5.088-15.254C168.504,175.212,170.176,175.212,170.57,176.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M133.789,139.613l5.088,15.254l16.079,0.125c1.246,0.01,1.762,1.599,0.76,2.339l-12.936,9.553 l4.851,15.331c0.376,1.187-0.977,2.17-1.991,1.446l-13.082-9.351l-13.082,9.351c-1.013,0.725-2.366-0.258-1.991-1.446l4.851-15.331 l-12.936-9.553c-1.002-0.74-0.486-2.329,0.76-2.339l16.079-0.125l5.088-15.254C131.722,138.431,133.394,138.431,133.789,139.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M97.006,102.831l5.088,15.254l16.079,0.125c1.246,0.01,1.762,1.599,0.76,2.339l-12.936,9.553 l4.851,15.331c0.376,1.187-0.977,2.17-1.991,1.446l-13.082-9.351l-13.082,9.351c-1.013,0.724-2.366-0.258-1.991-1.446l4.851-15.331 l-12.936-9.553c-1.002-0.74-0.486-2.329,0.76-2.339l16.079-0.125l5.088-15.254C94.941,101.65,96.612,101.65,97.006,102.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M354.478,360.302l5.088,15.254l16.079,0.125c1.246,0.01,1.762,1.599,0.76,2.339l-12.936,9.553 l4.851,15.331c0.376,1.187-0.977,2.171-1.99,1.446l-13.082-9.351l-13.082,9.351c-1.013,0.724-2.366-0.258-1.99-1.446l4.851-15.331 l-12.936-9.553c-1.002-0.74-0.486-2.329,0.76-2.339l16.079-0.125l5.088-15.254C352.413,359.121,354.084,359.121,354.478,360.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M317.696,323.521l5.088,15.254l16.079,0.125c1.246,0.01,1.762,1.599,0.76,2.339l-12.936,9.553 l4.851,15.331c0.376,1.187-0.977,2.171-1.99,1.446l-13.082-9.351l-13.082,9.351c-1.013,0.724-2.366-0.258-1.991-1.446l4.851-15.331 l-12.936-9.553c-1.002-0.74-0.486-2.329,0.76-2.339l16.079-0.125l5.088-15.254C315.63,322.339,317.302,322.339,317.696,323.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M280.915,286.74l5.088,15.254l16.079,0.125c1.246,0.01,1.762,1.599,0.76,2.339l-12.936,9.553 l4.851,15.331c0.376,1.187-0.977,2.171-1.99,1.446l-13.082-9.351l-13.082,9.351c-1.013,0.724-2.366-0.258-1.991-1.446l4.851-15.331 l-12.936-9.553c-1.002-0.74-0.486-2.329,0.76-2.339l16.079-0.125l5.088-15.254C278.849,285.558,280.521,285.558,280.915,286.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M244.134,249.958l5.088,15.254l16.079,0.125c1.246,0.01,1.762,1.599,0.76,2.339l-12.936,9.553 l4.851,15.331c0.376,1.187-0.977,2.17-1.991,1.445l-13.082-9.351l-13.082,9.351c-1.013,0.725-2.366-0.258-1.991-1.445l4.851-15.331 l-12.936-9.553c-1.002-0.74-0.486-2.329,0.76-2.339l16.079-0.125l5.088-15.254C242.068,248.776,243.738,248.776,244.134,249.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M41.942,88.276l6.83,5.044l-4.851,15.331c-0.375,1.187,0.977,2.17,1.991,1.447l13.081-9.351 l13.082,9.351c1.013,0.724,2.366-0.258,1.99-1.447l-4.85-15.331l6.833-5.044H41.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M412.427,412.463l-16.079-0.125l-5.087-15.254c-0.394-1.182-2.066-1.182-2.46,0l-5.087,15.254 l-16.079,0.125c-1.246,0.01-1.762,1.6-0.76,2.339l12.083,8.921h22.151l12.082-8.921 C414.189,414.062,413.673,412.472,412.427,412.463z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/ba.fa14591d86de93c88f264b29169b21df.svg";
export { ForwardRef as ReactComponent };